import {IconButton, Menu, MenuItem} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AssignmentIcon from "@mui/icons-material/Assignment";
import UpdateIcon from "@mui/icons-material/Update";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import {useState} from "react";
import {useTenantConfig} from "../../../security/tenant-config-context";
import type {Reservation} from "../NewReservationsOverview";

export function RowActions({
                               row, t, handleOpenEditModal, downloadContracts, requestValidate, requestCancel,
                           }: {
    row: Reservation;
    t: (k: string) => string;
    handleOpenEditModal: (uuid: string) => void;
    downloadContracts: (uuid: string) => Promise<any>;
    requestValidate: (uuid: string) => void;
    requestCancel: (uuid: string) => void;
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const {cfg} = useTenantConfig();
    const isHotelFlow = cfg?.businessTypes?.includes('HOTEL_BASED');

    return (<>
            <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)} aria-label={t("actions")}>
                <MoreVertIcon/>
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                {isHotelFlow && (<MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        handleOpenEditModal(row.uuid);
                    }}
                >
                    <UpdateIcon fontSize="small" style={{marginRight: 8}}/> {t("updateReservationHours")}
                </MenuItem>)}
                {isHotelFlow && (<MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        downloadContracts(row.uuid);
                    }}>
                    <AssignmentIcon fontSize="small" style={{marginRight: 8}}/> {t("download_contracts")}
                </MenuItem>)}
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        requestValidate(row.uuid);
                    }}
                >
                    <DoneIcon fontSize="small" style={{marginRight: 8}}/> {t("validate")}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        requestCancel(row.uuid);
                    }}
                    sx={{color: "error.main"}}
                >
                    <DeleteIcon fontSize="small" style={{marginRight: 8}}/> {t("cancel")}
                </MenuItem>
            </Menu>
        </>);
}
